const BaseComponent = require('base/base-component');

const colorArray = ['#B1DC97', '#B7DCF6', '#FFE0E1', '#FFCF76', '#D3D2D3', '#FFF09C'];

class mapNav extends BaseComponent {
  init () {
    const district = this.$el.find('[name=map-district]').val() || 'china';
    const borderColor = this.$el.find('[name=map-border-color]').val() || '#FF6300';
    const geochina = 'https://data.jianshukeji.com/jsonp?filename=geochina/';
    $.getJSON(geochina + district + '.json&callback=?', (mapdata) => {
      const data = [];
      // 随机数据
      Highcharts.each(mapdata.features, (md, index) => {
        const tmp = {
          name: md.properties.name,
          drilldown: md.properties.filename,
          color: colorArray[index % colorArray.length],
          value: Math.floor(Math.random() * 100 + 1) // 生成 1 ~ 100 随机值
        };
        data.push(tmp);
      });
      new Highcharts.Map('map-container', {
        chart: {
          backgroundColor: 'transparent',
          events: {
            drilldown: function(e) {
              // 异步下钻
              console.log('e.point.properties', e.point.properties);
              const { areacode } = e.point.properties;
              window.REGION.map(x => {
                if (areacode.toString() === x.districtCode) {
                  window.location.href = `http://${x.domain}/home.html`;
                }
              });
            },
            drillup: function() {
              map.setTitle({
                text: "中国"
              });
            }
          }
        },
        title: null,
        subtitle: null,
        legend: false,
        tooltip: {
          useHTML: true,
          headerFormat: '<table><tr><td>{point.name}</td></tr>',
          pointFormat:
            '<tr><td>{point.properties.fullname}</td></tr>' +
            '<tr><td>{point.properties.areacode}</td></tr>',
          footerFormat: '</table>'
        },
        series: [
          {
            data,
            mapData: mapdata,
            joinBy: 'name',
            dataLabels: {
              // https://api.hcharts.cn/highcharts#series%3Carea%3E.dataLabels.allowOverlap
              allowOverlap: true,
              enabled: true,
              formatter () {
                return this.point.properties.name;
              },
              style: {
                fontSize: '12px',
                color: '#333333',
              },
              x: 10
            },
            borderColor,
            borderWidth: 0.4,
            states: {
              hover: {
                color: '#a4edba'
              }
            }
          }
        ]
      });
    });
  }
}
module.exports = mapNav;
